import React, {Component} from 'react';
import PlanCard from './plan_card';
import {VIRTUAL_SEAT_PRICE} from '../../constants';
import {injectIntl} from 'react-intl';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';

class SelectPlan extends Component {
	componentDidMount() {
		tracking.trackPage('trial-end-select-plan');
	}

	navigateNext(planName) {
		this.props.navigateWithPlan(planName);
	}
	render() {
		const {formatMessage, formatNumber} = this.props.intl;
		const litePerks = [
			{label: formatMessage({id: 'select_plan.list.unlimited_projects'})},
			{label: formatMessage({id: 'select_plan.list.plan_and_run'})},
			{label: formatMessage({id: 'select_plan.list.track_time'})},
			{label: formatMessage({id: 'select_plan.list.basic_reports'})},
			// Spacer
			{label: null},
			{label: formatMessage({id: 'select_plan.list.basic_integrations'})},
			{label: formatMessage({id: 'select_plan.list.client_and_rates'})},
			{label: formatMessage({id: 'select_plan.list.budgeting'})},
			{label: formatMessage({id: 'select_plan.list.schedule'})},
			{label: formatMessage({id: 'select_plan.list.customizable_repports'})},
			{label: formatMessage({id: 'select_plan.list.contact_support'})},
			{label: null},
		];
		const proPerks = litePerks.concat([
			{label: formatMessage({id: 'select_plan.list.integration'})},
			{label: formatMessage({id: 'select_plan.list.retainer'})},
			{label: formatMessage({id: 'select_plan.list.contextual_onboarding'})},
			{label: formatMessage({id: 'select_plan.list.hopon_assistance'})},
			{label: formatMessage({id: 'select_plan.list.success_manager'})},
			{label: null},
		]);
		const enterprisePerks = proPerks.concat([{label: formatMessage({id: 'select_plan.list.migration_integration'})}, {label: formatMessage({id: 'select_plan.list.optimization_workshops'})}]);

		const currencySymbol = Util.GetCurrencySymbol(this.props.currency);
		const plans = this.props.plans.filter(plan => plan.currency === this.props.currency);
		const litePlan = plans.find(plan => plan.chargebeeId.includes('_lite_yearly'));
		const proPlan = plans.find(plan => plan.chargebeeId.includes('_pro_yearly'));
		const enterprisePlan = plans.find(plan => plan.chargebeeId.includes('_enterprise_yearly'));
		const virtualUserPrice = this.props.selectedVirtualUser
			? `${currencySymbol + this.props.selectedVirtualUser.price / 100} ${formatMessage({id: 'select_plan.per_virtual_seat'})}`
			: `$${VIRTUAL_SEAT_PRICE} ${formatMessage({id: 'select_plan.per_virtual_seat'})}`;
		const hasCompleteCurrencyData = litePlan && proPlan && enterprisePlan && this.props.selectedVirtualUser;

		return (
			<div className="choose-plan">
				<h1 className={'trial-ended-header'}>{formatMessage({id: 'common.trial_has_ended'})}</h1>
				<div className={'plans-container'}>
					<PlanCard
						selected={this.props.selectedPlan === 'LITE'}
						title={formatMessage({id: 'select_plan.lite_plan_name'}).toUpperCase()}
						subTitle={formatMessage({id: 'select_plan.lite_tagline'})}
						priceText={hasCompleteCurrencyData ? Util.getFormattedCurrencyValue(currencySymbol, formatNumber(litePlan.price / 100 / 12, {format: 'rounded_zero_decimal'})) : '$29'}
						unit={formatMessage({id: 'select_plan.seat'})}
						period={formatMessage({id: 'select_plan.Month'}) + '*'}
						additionalInfo={virtualUserPrice}
						minCountText={formatMessage({id: 'select_plan.minimum_seats'}, {amount: 10})}
						buttonText={formatMessage({id: 'common.select'}).toUpperCase()}
						onButtonClick={this.navigateNext.bind(this, 'LITE')}
						savingsTitle={formatMessage({id: 'select_plan.professional_plan_price_disclaimer'})}
						perksList={litePerks}
						perkListHeader={formatMessage({id: 'select_plan.you_get'})}
						perkListExpanded={this.props.perkListsExpanded}
						jiraCloudEnabled={this.props.viewer.company.jiraCloudEnabled}
						jiraServerEnabled={this.props.viewer.company.jiraServerEnabled}
					/>
					<PlanCard
						selected={this.props.selectedPlan === 'PRO'}
						title={formatMessage({id: 'select_plan.pro_plan_name'}).toUpperCase()}
						subTitle={formatMessage({id: 'select_plan.pro_tagline'})}
						priceText={hasCompleteCurrencyData ? Util.getFormattedCurrencyValue(currencySymbol, formatNumber(proPlan.price / 100 / 12, {format: 'rounded_zero_decimal'})) : '$49'}
						unit={formatMessage({id: 'select_plan.seat'})}
						period={formatMessage({id: 'select_plan.Month'}) + '*'}
						additionalInfo={virtualUserPrice}
						minCountText={formatMessage({id: 'select_plan.minimum_seats'}, {amount: 10})}
						buttonText={formatMessage({id: 'common.select'}).toUpperCase()}
						onButtonClick={this.navigateNext.bind(this, 'PRO')}
						savingsTitle={formatMessage({id: 'select_plan.professional_plan_price_disclaimer'})}
						perksList={proPerks}
						perkListHeader={formatMessage({id: 'select_plan.you_get'})}
						perkListExpanded={this.props.perkListsExpanded}
					/>
					<PlanCard
						selected={this.props.selectedPlan === 'ENTERPRISE'}
						title={formatMessage({id: 'select_plan.enterprise_plan_name'}).toUpperCase()}
						subTitle={formatMessage({id: 'select_plan.enterprise_tagline'})}
						priceText={hasCompleteCurrencyData ? Util.getFormattedCurrencyValue(currencySymbol, formatNumber(enterprisePlan.price / 100 / 12, {format: 'rounded_zero_decimal'})) : '$69'}
						unit={formatMessage({id: 'select_plan.seat'})}
						period={formatMessage({id: 'select_plan.Month'}) + '*'}
						additionalInfo={virtualUserPrice}
						minCountText={formatMessage({id: 'select_plan.minimum_seats'}, {amount: 10})}
						buttonText={formatMessage({id: 'common.select'}).toUpperCase()}
						onButtonClick={this.navigateNext.bind(this, 'ENTERPRISE')}
						savingsTitle={formatMessage({id: 'select_plan.professional_plan_price_disclaimer'})}
						perksList={enterprisePerks}
						perkListHeader={formatMessage({id: 'select_plan.you_get'})}
						perkListExpanded={this.props.perkListsExpanded}
					/>
				</div>
			</div>
		);
	}
}

export default injectIntl(SelectPlan);
